import { makeStyles } from "@material-ui/core";

export const useActionIconButtonStyles = makeStyles(() => ({
    icon: {
        display: "inline-block"
    }
}));
